/* ============================================================
   ALPYRAMID — Global behaviours shared by the custom sections
   Load ONCE globally with `defer` (see GUIDE.md).
   Section-specific JS (FAQ accordion, product filter) lives
   inside each section file so it initialises per-instance.
   ============================================================ */
(function () {
  'use strict';

  /* --- SCROLL REVEAL (Intersection Observer) --- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.alp-section .reveal');
    if (!els.length) return;

    // In the theme editor show everything immediately.
    if (window.Shopify && Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('active'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('active'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --- CUSTOM CURSOR (desktop only, optional) ---
     Enabled only when <body> has the class `alp-custom-cursor`
     (toggle in GUIDE.md). Skipped on touch devices. */
  function initCustomCursor() {
    if (!document.body.classList.contains('alp-custom-cursor')) return;
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

    var cursor = document.createElement('div');
    cursor.className = 'alp-cursor';
    var follower = document.createElement('div');
    follower.className = 'alp-cursor-follower';
    document.body.appendChild(cursor);
    document.body.appendChild(follower);

    var mx = 0, my = 0, fx = 0, fy = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top = my + 'px';
    });
    (function loop() {
      fx += (mx - fx) * 0.15;
      fy += (my - fy) * 0.15;
      follower.style.left = fx + 'px';
      follower.style.top = fy + 'px';
      requestAnimationFrame(loop);
    })();
  }

  function init() {
    initScrollReveal();
    initCustomCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run reveal when a section is added/reloaded in the editor.
  document.addEventListener('shopify:section:load', initScrollReveal);
})();
